import { RbcApi } from '@calm/evexia-web-sdk/generated/lib/api/rbc-api';
import { AxiosInstance } from 'axios';
import { createApi } from './create-api';

/**
 * Helper function to configure and create a new instance of an `RbcApi`
 * @param accessToken
 * @returns
 */
export default function createRbcApi(
    accessToken: () => Promise<string>,
    client?: AxiosInstance
) {
    return createApi(RbcApi, accessToken, undefined, client);
}
